(ns app.domain.licence.generic-model
  "Licences and Contractor Registrations have many similarities. This namespace provides helpers to access
  those parts."
  (:require [app.domain.verdict.model :as verdict-model]))

(defmulti get-workspaces :entity/type)

(defmethod get-workspaces :entity.type/licence
  [licence]
  (:licence/workspaces licence))

(defmethod get-workspaces :entity.type/contractor-registration
  [cr]
  (:contractor-registration/workspaces cr))

(defmulti get-verdict :entity/type)

(defmethod get-verdict :entity.type/licence
  [licence]
  (:licence/verdict licence))

(defmethod get-verdict :entity.type/contractor-registration
  [cr]
  (:contractor-registration/verdict cr))

(defmulti get-valid-to :entity/type)

(defmethod get-valid-to :entity.type/licence
  [licence]
  (:licence/valid-to licence))

(defmethod get-valid-to :entity.type/contractor-registration
  [cr]
  (:contractor-registration/valid-to cr))

(defmulti get-valid-from :entity/type)

(defmethod get-valid-from :entity.type/licence
  [licence]
  (:licence/valid-from licence))

(defmethod get-valid-from :entity.type/contractor-registration
  [cr]
  (:contractor-registration/valid-from cr))

(defmulti get-holder-names :entity/type)

(defmethod get-holder-names :entity.type/licence
  [licence]
  (:licence/holder-names licence))

(defmethod get-holder-names :entity.type/contractor-registration
  [cr]
  (:contractor-registration/registrant-names cr))

(defmulti get-holder-entity :entity/type)

(defmethod get-holder-entity :entity.type/licence
  [licence]
  (:licence/issued-to licence))

(defmethod get-holder-entity :entity.type/contractor-registration
  [cr]
  (:contractor-registration/registrant cr))

(defn licence-issued-workspace
  "Returns the latest workspace with licence issued linked to the licence"
  [licence]
  (-> licence
      get-verdict
      verdict-model/get-workspace))

(defn issue-date [licence]
  (some-> licence get-verdict :verdict/issue-date))

(def holder-revocation-letter-template-variables
  ["holder-street-address"
   "holder-postal-code"
   "holder-municipality"
   "holder-mobile-phone"
   "holder-state-or-province"])

(def revocation-letter-common-template-variables
  ["header"
   "issued-to"
   "revocation-date"
   "revocation-reason"
   "date-issued"
   "valid-from"
   "valid-to"
   "latest-application-number"])
